import {User} from '../../../shared/models';
import {StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class StudentsForImpactDetailsResolver implements Resolve<User> {

  constructor( @Inject(StudentsForImpactService) private service: StudentsForImpactService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
    return this.service.findByIdAndFetchDetails(+route.paramMap.get('id'), true);
  }
}
